import type { HmpDashboard, Vacature, Task } from "../api/api";
import { listVacaturesByIds } from "../api/api";

export type SwipeCard = HmpDashboard["stale_vacatures"][number];

// vacatureToSwipeCard maps a full Vacature (from the bulk /vacatures?ids=
// fetch) to the SwipeReview card shape — everything matches 1:1 except
// days_since_update, which SwipeReview needs but Vacature doesn't carry, so
// it's computed here from updated_at.
export function vacatureToSwipeCard(v: Vacature): SwipeCard {
  const daysSinceUpdate = v.updated_at
    ? Math.floor((Date.now() - new Date(v.updated_at).getTime()) / 86_400_000)
    : 0;
  return {
    id: v.id,
    functie: v.functie,
    locatie: v.locatie,
    days_since_update: daysSinceUpdate,
    opmerkingen: v.opmerkingen,
    status: v.status,
    priority: v.priority,
    bemiddeling_status: v.bemiddeling_status,
    contactpersoon: v.contactpersoon,
    aantal_posities: v.aantal_posities,
    salary_type: v.salary_type,
    salary_min: v.salary_min,
    salary_max: v.salary_max,
    salary_fixed: v.salary_fixed,
    salary_other: v.salary_other,
  };
}

/** Where clicking a task leads. Returns the route and optional router state, or null when there's no target. */
export async function taskTarget(task: Task): Promise<{ to: string; state?: unknown } | null> {
  switch (task.type) {
    case "stale_vacature": {
      const primary = task.related_vacature_ids ?? [];
      const secondary = task.secondary_vacature_ids ?? [];
      // With nothing in the primary batch the review starts on the extra one.
      const ids = primary.length > 0 ? primary : secondary;
      if (ids.length === 0) return null;
      const { data } = await listVacaturesByIds(ids);
      return {
        to: "/swipe-review",
        state: { cards: data.map(vacatureToSwipeCard), title: task.message, secondaryIds: primary.length > 0 ? secondary : [] },
      };
    }
    case "email_approval":
      return { to: "/mail-goedkeuring" };
    case "branch_access_request":
      return { to: "/toegangsverzoeken" };
    case "kam_no_partner_permissions":
    case "hmp_no_branch_permissions":
    case "hmp_no_kam":
      return { to: "/gebruikersbeheer" };
    case "partner_no_users":
      return { to: "/partnerbeheer" };
    default:
      console.warn(`no click handler for task type "${task.type}"`);
      return null;
  }
}
